import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  TextField,
  Typography,
  Paper,
  Button,
  IconButton,
  OutlinedInput,
  InputAdornment,
  useMediaQuery,
  Alert,
  Card,
  CardContent,
  Divider,
  Chip,
  Stack,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  AddCircleOutline,
  RemoveCircleOutline,
  ShoppingCart,
  LocalShipping,
  Security,
  CheckCircle,
} from "@mui/icons-material";
import item from "../components/assets/item.png";
import item2 from "../components/assets/item2.png";
import { Banner } from "../components/Utilities/Snackbar";
import logo from "../components/assets/logo-pet.png";
import Spinner from "../components/Utilities/Spinner";
import { Link } from "react-router-dom";

const Order = () => {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [formValid, setFormValid] = useState(false);
  const [emailValid, setEmailValid] = useState(true);
  const isMobile = useMediaQuery("(max-width:600px)");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [isLoading, setIsLoading] = useState(false);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleIncrease = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleInputChange = () => {
    const firstName = document.getElementById("firstName").value.trim();
    const lastName = document.getElementById("lastName").value.trim();
    const phoneNumber = document.getElementById("phoneNumber").value.trim();
    const email = document.getElementById("email").value.trim();
    const address = document.getElementById("address").value.trim();

    const emailIsValid = isValidEmail(email);
    setEmailValid(emailIsValid);

    setFormValid(
      firstName && lastName && phoneNumber && emailIsValid && address
    );
  };

  const placeOrder = async () => {
    const firstName = document.getElementById("firstName").value.trim();
    const lastName = document.getElementById("lastName").value.trim();
    const phoneNumber = document.getElementById("phoneNumber").value.trim();
    const email = document.getElementById("email").value.trim();
    const address = document.getElementById("address").value.trim();

    setIsLoading(true);
    try {
      await axios.post(`${global.config.serverUrl}/order/`, {
        email: email,
        name: `${firstName} ${lastName}`,
        phoneNumber: phoneNumber,
        address: address,
        orderQuantity: quantity,
      });
      setIsLoading(false);
      setSnackbarOpen(true);
      setSnackbarSeverity("success");
      setSnackbarMessage(
        "Order successfully set! Please check your email for instructions."
      );

      setTimeout(() => {
        navigate(`/about-us`);
      }, 3000);
    } catch (error) {
      setSnackbarMessage("Error placing the order. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setIsLoading(false);
    }
  };

  const totalPrice = quantity * 15.0;
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f5dc 0%, #e8e2c2 100%)",
        py: 4,
      }}
    >
      <Container maxWidth="lg">
        {/* Header */}
        <Box textAlign="center" mb={4}>
          <Link
            to="/"
            style={{
              textDecoration: "none",
              display: "block",
              marginBottom: "-10px",
            }}
          >
            <img
              src={logo}
              alt="That's My Pet Logo"
              style={{
                width: isMobile ? "200px" : "250px",
                height: "auto",
                cursor: "pointer",
                filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))",
              }}
            />
          </Link>
          <Typography
            variant="h4"
            sx={{
              mt: 0,
              fontWeight: 700,
              color: "#2c3e50",
              textAlign: "center",
            }}
          >
            Order Your Pet Tag
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: "#7f8c8d",
              textAlign: "center",
              mt: 1,
            }}
          >
            Keep your pet safe with our premium identification tags
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {/* Order Form */}
          <Grid item xs={12} md={8}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 4 }}>
                <Typography
                  variant="h6"
                  sx={{ mb: 3, fontWeight: 600, color: "#2c3e50" }}
                >
                  Shipping Information
                </Typography>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      variant="outlined"
                      id="firstName"
                      onChange={handleInputChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: "#B4D479",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#B4D479",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      variant="outlined"
                      id="lastName"
                      onChange={handleInputChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: "#B4D479",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#B4D479",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone Number"
                      variant="outlined"
                      id="phoneNumber"
                      onChange={handleInputChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: "#B4D479",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#B4D479",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      variant="outlined"
                      id="email"
                      onChange={handleInputChange}
                      required
                      error={!emailValid}
                      helperText={
                        !emailValid ? "Please enter a valid email address" : ""
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: "#B4D479",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#B4D479",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Complete Address"
                      variant="outlined"
                      id="address"
                      onChange={handleInputChange}
                      required
                      multiline
                      rows={2}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: "#B4D479",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#B4D479",
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Order Summary */}
          <Grid item xs={12} md={4}>
            <Card
              elevation={3}
              sx={{ borderRadius: 3, position: "sticky", top: 20 }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{ mb: 3, fontWeight: 600, color: "#2c3e50" }}
                >
                  Order Summary
                </Typography>

                {/* Product Display */}
                <Box sx={{ mb: 3 }}>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <img
                        src={item}
                        alt="Pet Tag Front"
                        style={{
                          width: "60px",
                          height: "75px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                      />
                      <img
                        src={item2}
                        alt="Pet Tag Back"
                        style={{
                          width: "60px",
                          height: "75px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                      />
                    </Box>
                    <Box ml={2}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        Premium Pet Tag
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Durable & Weather-resistant
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      sx={{ mb: 1 }}
                    >
                      Quantity:
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{
                        mb: 1,
                        fontWeight: 600,
                        minWidth: "40px",
                        textAlign: "center",
                      }}
                    >
                      {quantity}
                    </Typography>

                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      gap={1}
                    >
                      <IconButton
                        onClick={handleDecrease}
                        disabled={quantity <= 1}
                        sx={{
                          color: "#B4D479",
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                          "&:focus": {
                            backgroundColor: "transparent",
                          },
                        }}
                        disableRipple
                      >
                        <RemoveCircleOutline />
                      </IconButton>
                      <IconButton
                        onClick={handleIncrease}
                        sx={{
                          color: "#B4D479",
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                          "&:focus": {
                            backgroundColor: "transparent",
                          },
                        }}
                        disableRipple
                      >
                        <AddCircleOutline />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Price Breakdown */}
                <Box sx={{ mb: 3 }}>
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography variant="body2">
                      Tag Price ({quantity} × $15.00)
                    </Typography>
                    <Typography variant="body2">
                      ${(quantity * 15.0).toFixed(2)}
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={1}>
                    <Typography variant="body2" color="text.secondary">
                      Subscription & Delivery
                    </Typography>
                    <Typography variant="body2" color="success.main">
                      Included
                    </Typography>
                  </Box>
                  <Divider sx={{ my: 1 }} />
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="h6" fontWeight={600}>
                      Total
                    </Typography>
                    <Typography variant="h6" fontWeight={600} color="primary">
                      ${totalPrice.toFixed(2)}
                    </Typography>
                  </Box>
                </Box>

                {/* Features */}
                <Box sx={{ mb: 3 }}>
                  <Stack spacing={1}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <CheckCircle sx={{ color: "#B4D479", fontSize: 16 }} />
                      <Typography variant="body2">
                        Free delivery across Lebanon
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Security sx={{ color: "#B4D479", fontSize: 16 }} />
                      <Typography variant="body2">
                        Secure payment processing
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      <LocalShipping sx={{ color: "#B4D479", fontSize: 16 }} />
                      <Typography variant="body2">
                        Fast & reliable shipping
                      </Typography>
                    </Box>
                  </Stack>
                </Box>

                {/* Place Order Button */}
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={placeOrder}
                  disabled={!formValid || isLoading}
                  startIcon={<ShoppingCart />}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    fontWeight: 600,
                    fontSize: "1.1rem",
                    backgroundColor: formValid ? "#B4D479" : "#bdbdbd",
                    color: formValid ? "#2c3e50" : "#757575",
                    "&:hover": {
                      backgroundColor: formValid ? "#9bc654" : "#bdbdbd",
                    },
                    "&:disabled": {
                      backgroundColor: "#bdbdbd",
                      color: "#757575",
                    },
                  }}
                >
                  {isLoading ? "Processing..." : "Place Order"}
                </Button>

                {/* Info Alert */}
                <Alert
                  severity="info"
                  sx={{
                    mt: 2,
                    borderRadius: 2,
                    backgroundColor: "rgba(180, 212, 121, 0.1)",
                    border: "1px solid rgba(180, 212, 121, 0.3)",
                    "& .MuiAlert-icon": {
                      color: "#B4D479",
                    },
                  }}
                >
                  <Typography variant="body2">
                    Complete package includes the tag, subscription service, and
                    delivery throughout Lebanon.
                  </Typography>
                </Alert>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Footer */}
        <Box
          sx={{
            mt: 5,
            backgroundColor: "#353634",
            borderTop: "3px solid #B4D479",
            py: 4,
            textAlign: "center",
            width: "100%",
          }}
        >
          <Container maxWidth="lg">
            <Typography
              variant="body2"
              sx={{
                color: "#B4D479",
                fontSize: "0.875rem",
              }}
            >
              © {new Date().getFullYear()} That's My Pet. All rights reserved. •
              Digital pet identities
            </Typography>
          </Container>
        </Box>
      </Container>

      <Banner
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      <Spinner open={isLoading} />
    </Box>
  );
};

export default Order;
